var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96191 8.3252C2.43555 8.72559 2.93359 8.43262 2.93359 7.91504V7.16309H5.31152V9.5459H4.54492C4.04199 9.5459 3.75391 10.0488 4.13477 10.5029L5.47754 12.0703C5.75586 12.4121 6.22461 12.4316 6.5127 12.0801L7.85547 10.5176C8.25586 10.0439 7.96289 9.5459 7.44531 9.5459H6.69336V7.16309H9.06641V7.91504C9.06641 8.43262 9.56445 8.72559 10.0381 8.3252L11.6006 6.9873C11.957 6.69434 11.9326 6.22559 11.5908 5.94727L10.0234 4.60449C9.56934 4.22363 9.06641 4.51172 9.06641 5.01953V5.78125H6.69336V3.39844H7.44531C7.96289 3.39844 8.25586 2.90039 7.85547 2.42676L6.5127 0.859375C6.21973 0.507812 5.75098 0.537109 5.47266 0.874023L4.13477 2.44141C3.75391 2.89551 4.04199 3.39844 4.54492 3.39844H5.31152V5.78125H2.93359V5.01953C2.93359 4.51172 2.43066 4.22363 1.97656 4.60449L0.40918 5.94727C0.0722656 6.2207 0.0380859 6.68945 0.394531 6.98242L1.96191 8.3252Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-move.d1f1eaca60ae51ac08743b5cca382d8e.svg";